import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// import Components
import { useSelector, useDispatch } from 'react-redux';
import NavigateV2Alert from 'Components/Common/NavigateV2Alert';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
// import RightSidebar from '../../Components/Common/RightSidebar';

// import actions
import {
  changeLayout,
  changeSidebarTheme,
  changeLayoutMode,
  changeLayoutWidth,
  changeLayoutPosition,
  changeTopbarTheme,
  changeLeftsidebarSizeType,
  changeLeftsidebarViewType,
} from '../../store/layouts/layoutSlice';

// redux

const Layout = ({ children }) => {
  const [headerClass, setHeaderClass] = useState('');
  const [isV2AlertVisible, setIsV2AlertVisible] = useState(false);
  const dispatch = useDispatch();
  const {
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
  } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
    leftSidebarType: state.Layout.leftSidebarType,
    layoutModeType: state.Layout.layoutModeType,
    layoutWidthType: state.Layout.layoutWidthType,
    layoutPositionType: state.Layout.layoutPositionType,
    topbarThemeType: state.Layout.topbarThemeType,
    leftsidbarSizeType: state.Layout.leftsidbarSizeType,
    leftSidebarViewType: state.Layout.leftSidebarViewType,
  }));
  // class add remove in header

  function scrollNavigation() {
    const scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setHeaderClass('topbar-shadow');
    } else {
      setHeaderClass('');
    }
  }
  useEffect(() => {
    window.addEventListener('scroll', scrollNavigation, true);
  });
  /*
    layout settings
    */
  useEffect(() => {
    if (
      layoutType ||
      leftSidebarType ||
      layoutModeType ||
      layoutWidthType ||
      layoutPositionType ||
      topbarThemeType ||
      leftsidbarSizeType ||
      leftSidebarViewType
    ) {
      dispatch(changeLeftsidebarViewType(leftSidebarViewType));
      dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
      dispatch(changeSidebarTheme(leftSidebarType));
      dispatch(changeLayoutMode(layoutModeType));
      dispatch(changeLayoutWidth(layoutWidthType));
      dispatch(changeLayoutPosition(layoutPositionType));
      dispatch(changeTopbarTheme(topbarThemeType));
      dispatch(changeLayout(layoutType));
    }
  }, [
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    dispatch,
  ]);
  const additionalSidebarClass = isV2AlertVisible ? 'sidebar-top-2' : '';
  const additionalHeaderClass = isV2AlertVisible ? 'header-margin-2' : '';
  /*
    call dark/light mode
    */
  const onChangeLayoutMode = (value) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };

  return (
    <>
      <NavigateV2Alert setIsV2AlertVisible={setIsV2AlertVisible} />
      <div id='layout-wrapper'>
        <Header
          additionalClass={additionalHeaderClass}
          headerClass={headerClass}
          layoutModeType={layoutModeType}
          onChangeLayoutMode={onChangeLayoutMode}
        />

        <Sidebar
          additionalClass={additionalSidebarClass}
          layoutType={layoutType}
        />
        <div className='main-content'>
          {children}
          {/* <Footer /> */}
        </div>
      </div>
      {/* <RightSidebar /> */}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withRouter(Layout);
